import React from 'react';

export const AssociarContexto = React.createContext(null);